/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47923Req {
  
  /** 任务id */
  taskId?: number;
  /** 关联的okr编号 */
  okrKrNo?: string;
  /** 关联的上级O编号 */
  okrONo?: string;
  /** 是否删除：true:断开false：关联(默认) */
  isDelete?: boolean;
};



export type API47923Res = {};


// 47923 关联OKR

export interface IUsePostAPI47923Return {
  /** 关联OKR: 接口请求状态 */
  isAPI47923Loading: boolean;
  /** 关联OKR: 接口请求返回数据 */
  dataAPI47923: API47923Res;
  /**  关联OKR: 接口数据请求方法 */
  fetchAPI47923Data:  (inputs: API47923Req, config?: YWRequestConfig) => Promise<API47923Res>;
  /** 关联OKR: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI47923 = ():IUsePostAPI47923Return => {
  let isMount = true;
  const [isAPI47923Loading, setIsAPI47923Loading] = useState(false);
  const [dataAPI47923, setDataAPI47923] = useState<API47923Res>({} as API47923Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/relateOKR`;

  const fetchAPI47923Data = async (inputs: API47923Req, config?: YWRequestConfig): Promise<API47923Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47923Req>) || {}) as API47923Req;
    
  
    if ( isMount ) {
      setIsAPI47923Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47923Res>(`${basePath}/corp-admin/project/plan/task/relateOKR`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47923(res || {} as API47923Res);
        setIsAPI47923Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47923Loading(false);
      }
      return false as unknown as API47923Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47923Loading,
    dataAPI47923,
    fetchAPI47923Data,
    requestUrl,
  }
}

